import { render, staticRenderFns } from "./UserDashboardTabsTransactions.vue?vue&type=template&id=5ab083de&scoped=true&"
import script from "./UserDashboardTabsTransactions.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabsTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab083de",
  null
  
)

export default component.exports